import { render, staticRenderFns } from "./businessGoodsPrice.vue?vue&type=template&id=23079476&scoped=true"
import script from "./businessGoodsPrice.vue?vue&type=script&lang=js"
export * from "./businessGoodsPrice.vue?vue&type=script&lang=js"
import style0 from "./businessGoodsPrice.vue?vue&type=style&index=0&id=23079476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23079476",
  null
  
)

export default component.exports